<template>
  <div>
    <div class="text-xs-center mt-4 mb-4" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else-if="user">
      <template style="display: flex; flex-direction: column">
        <!-- ปุ่มดูประวัติ -->
        <!-- <div >{{ 'button' }}</div> -->
        <div style="display: flex; justify-content: flex-end" v-if="user.member_id">
          <img
            @click="
              showHistory = true
              depamemberlog()
            "
            style="cursor: pointer; margin-top: 16px; margin-right: 14px; height: 40px; width: 40px"
            src="/static/img/FileHistIcon.svg"
            alt=""
          />
        </div>
        <div
          v-else
          style="cursor: pointer; margin-top: 16px; margin-right: 14px; height: 40px; width: 40px"
        ></div>
        <v-dialog v-model="showHistory" width="570px" persistent>
          <v-card style="border-radius: 10px">
            <div class="pa-4">
              <div style="display: flex; justify-content: space-between; align-items: center">
                <!-- <span class="rsu color-darkBlue bold7 fs-24">
              ประวัติ
            </span> -->
                <Typography h2 bold label="ประวัติ" />
                <v-icon @click="showHistory = false">close</v-icon>
              </div>
              <div class="rsu">
                <v-layout row wrap>
                  <v-data-table
                    expand
                    hide-actions
                    :loading="loading"
                    :headers="[
                      {
                        text: 'วันที่ / เวลา',
                        align: 'center',
                        value: 'date'
                      },
                      {
                        text: 'รายการ',
                        align: 'center',
                        value: 'name'
                      },
                      {
                        text: 'ผู้ดำเนินการ',
                        align: 'center',
                        value: 'adminid'
                      }
                    ]"
                    :items="depamemberlogs"
                    select-all
                    item-key="name"
                    class="elevation-1"
                    style="height: 400px"
                  >
                    <template v-slot:headers="props">
                      <tr style="background-color: #152d53; color: white">
                        <th
                          style="background-color: #152d53; color: yellow"
                          v-for="header in props.headers"
                          :key="header.text"
                        >
                          <div>{{ header.text }}</div>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr style="cursor: pointer">
                        <td class="text-xs-left">
                          {{
                            props.item.updated_at
                              ? props.item.updated_at
                              : '-' | DateFormat('DD/MM/YYYY HH:MM')
                          }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.name ? props.item.name : '-' }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.adminid ? props.item.adminid : '-' }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-layout>
              </div>
            </div>
          </v-card>
        </v-dialog>

        <!-- รูป -->
        <div style="display: flex; justify-content: center">
          <v-avatar size="100">
            <template v-if="user.profile_pic">
              <v-img
                :src="user.profile_pic"
                aspect-ratio="1"
                class="grey lighten-2"
                @error="imgError(this)"
              >
                <template v-slot:placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </template>
            <v-img
              v-else
              :src="'/static/img/assets/livechat/profile.png'"
              aspect-ratio="1"
              class="grey lighten-2"
            ></v-img>
          </v-avatar>
        </div>

        <!-- ชือ Avatar -->
        <div
          style="
              display: flex;
              justify-content: center;
              font-weight: 700;
              font-size: 22px;
              color: #0c2f53;
            "
        >
          {{ user.first_name + ' ' + user.last_name }}
        </div>

        <div
          style="
              padding-left: 16px;
              padding-right: 16px;
              padding-bottom: 22px;
              display: flex;
              flex-direction: column;   
            "
        >
          <div style="margin-top: 21px;">
            <div v-for="(item, index) in UserInfoTitle" :key="index">
              <div style="display: flex; margin-top: 9px">
                <span class="left">{{ item }}</span>
                <span class="right">{{ UserInfo[index] }}</span>
              </div>
            </div>
          </div>

          <!-- <div style="display: flex; margin-top: 21px">
            <span class="left">{{ 'รหัสสมาชิก : ' }}</span>
            <span v-if="user.member_id != undefined && 
            user.member_id != undefined" class="right">{{ user.member_id }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'เลขบัตรประจำตัวประชาชน : ' }}</span>
            <span v-if="user.member_info[0] != undefined && 
            user.member_info[0].id_card != undefined" class="right">{{
              user.member_info[0].id_card }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'ชื่อ - นามสกุล : ' }}</span>
            <span v-if="
              user.member_info[0] != undefined &&
              user.member_info[0].coordinator_name != undefined
            " class="right">{{ user.member_info[0].coordinator_name }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'วันเกิด : ' }}</span>
            <span v-if="user.member_info[0] != undefined && 
            user.member_info[0].dob != undefined" class="right">{{
              user.member_info[0].dob | DateFormat('DD/MM/YYYY') }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'เบอร์ : ' }}</span>
            <span v-if="
              user.member_info[0] != undefined && 
              user.member_info[0].phone_number != undefined
            " class="right">{{ user.member_info[0].phone_number }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'อีเมล : ' }}</span>
            <span v-if="user.member_info[0] != undefined && 
            user.member_info[0].email != undefined" class="right">{{
              user.member_info[0].email }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'ประเภทสมาชิก : ' }}</span>
            <span v-if="user.membertype[0] != undefined &&
            user.membertype[0] != undefined" class="right">{{ user.membertype[0] }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'ประเภท : ' }}</span>
            <span v-if="user.member_info[0] != undefined && 
            user.member_info[0].dptype != undefined" class="right">{{
              user.member_info[0].dptype }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'เลขเกษตรกร : ' }}</span>
            <span v-if="user.member_info[0] != undefined && 
            user.member_info[0].profile_center_id != undefined" class="right">{{
              user.member_info[0].profile_center_id }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'เข้าร่วมวันที่ : ' }}</span>
            <span v-if="user.member_info[0] != undefined && 
            user.member_info[0].timestamp != undefined" class="right">{{
              user.member_info[0].timestamp | DateFormat('DD/MM/YYYY') }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div> -->

          <div
            style="
                display: flex;
                border-top: 1px solid black;   
                padding-top: 18px;
                margin-top: 18px;
                font-weight: 700;
                font-size: 18px;  
                color: #0c2f53;  
              "
          >
            {{ 'ข้อมูลร้านค้า' }}
          </div>

          <div v-for="(item, index) in StoreInfoTitle" :key="index">
            <div style="display: flex; margin-top: 9px">
              <span class="left">{{ item }}</span>
              <span class="right">{{ StoreInfo[index] }}</span>
            </div>
          </div>
          <!-- <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'ชื่อบริษัท : ' }}</span>
            <span v-if="user.tp_info[0] != undefined && 
            user.tp_info[0].name != undefined" class="right">{{
              user.tp_info[0].name }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'เว็บไซต์ : ' }}</span>
            <span v-if="user.tp_info[0] != undefined && 
            user.tp_info[0].website != undefined" class="right">{{
              user.tp_info[0].website }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'เบอร์ : ' }}</span>
            <span v-if="user.tp_info[0] != undefined && 
            user.tp_info[0].phone != undefined" class="right">{{
              user.tp_info[0].phone }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div>
          <div style="display: flex; margin-top: 9px">
            <span class="left">{{ 'ตัวแทนขาย : ' }}</span>
            <span v-if="
              user.tp_info[0] != undefined && 
              user.tp_info[0].salesrepresentatives != undefined
            " class="right">{{ user.tp_info[0].salesrepresentatives }}</span>
            <span v-else class="right">{{ '-' }}</span>
          </div> -->

          <div
            style="
                display: flex;
                border-top: 1px solid black;
                padding-top: 18px;
                margin-top: 18px; 
                font-weight: 700;
                font-size: 18px; 
                color: #0c2f53; 
              "
          >
            {{ 'ข้อมูล - เพิ่มโดยแอดมิน' }}
          </div>

          <div style="margin-top: 9px; display: flex; flex-direction: column;">
            <div style="display: flex;">
              <!-- ยังไม่มี -->
              <span class="left">{{ 'Note รายละเอียด : ' }}</span>
              <span
                style="max-width: 200px; overflow: hidden; white-space: pre-wrap; margin-left: 3px; font-weight: 400; font-size: 14px; color: #0c2f53; "
                >{{ user.note }}</span
              >
              <img
                v-if="showAdminNoteBox == false"
                @click="showAdminNoteBox = true"
                style="cursor: pointer; margin-left: auto; height: 19px; width: 19px"
                src="/static/img/edit.svg"
                alt=""
              />
            </div>
            <div v-if="showAdminNoteBox == true">
              <textarea
                id="adminNote"
                class="textBox"
                style="color: #2C2C2C; font-weight: 600;"
                v-model="user.note"
              ></textarea>

              <div style="justify-content: center">
                <div class="text-xs-center rsu" style="">
                  <v-btn
                    @click="showAdminNoteBox = false"
                    style="width: 57px; height: 19px; box-shadow: none; background: #FFFFFF; border: 1px solid #0C2F53; border-radius: 2px; font-size: 10px; font-weight: 600; color: #0C2F53;"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    @click="
                      {
                        showAdminNoteBox = false
                        POSTupdateUserNoteDetail()
                      }
                    "
                    style="width: 57px; height: 19px; box-shadow: none; background: linear-gradient(274.72deg, #0C2F53 7.12%, #26588B 99.76%); border: 1px solid #0C2F53; border-radius: 2px; font-size: 10px; font-weight: 600; color: #FFEF01;"
                  >
                    {{ $t('Save') }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>

          <div style="margin-top: 9px; display: flex; flex-direction: column;">
            <div style="display: flex;">
              <!-- ยังไม่มี -->
              <span class="left">{{ 'ป้ายกำกับ : ' }}</span>
              <!-- <span v-if="false">{{ 'ยังไม่มี' }}</span> -->
              <span
                style="max-width: 180px; overflow-wrap: hidden; white-space: pre-wrap; margin-left: 3px;"
              >
                <span v-for="(tag, index) in selectedTags" :key="index" class="tag">
                  {{ tag }}
                </span>
              </span>

              <!-- <span v-else-if="false">{{ 'ยังไม่มี' }}</span> -->
              <img
                v-if="showAdminTagBox == false"
                @click="showAdminTagBox = true"
                style="cursor: pointer; margin-left: auto; height: 19px; width: 19px"
                src="/static/img/edit.svg"
                alt=""
              />
            </div>
            <div v-if="showAdminTagBox == true">
              <!-- <textarea id="adminNote" style="overflow-y: hidden; align-items: start !important; font-size: 10px; text-align: left; padding: 5px; box-shadow: none; width: 243px; height: 77px; background: #FFFFFF; border: 1px solid #0C2F53; border-radius: 11px;"></textarea> -->

              <multiselect
                v-model="selectedTags"
                :options="tagOptions"
                :placeholder="''"
                :taggable="true"
                :multiple="true"
                @tag="addTag($event)"
                class="multi-tag-small custom-scroll"
              ></multiselect>

              <div style="justify-content: center">
                <div class="text-xs-center rsu" style="">
                  <v-btn
                    @click="showAdminTagBox = false"
                    style="width: 57px; height: 19px; box-shadow: none; background: #FFFFFF; border: 1px solid #0C2F53; border-radius: 2px; font-size: 10px; font-weight: 600; color: #0C2F53;"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    @click="
                      showAdminTagBox = false
                      PUTusertags()
                    "
                    style="width: 57px; height: 19px; box-shadow: none; background: linear-gradient(274.72deg, #0C2F53 7.12%, #26588B 99.76%); border: 1px solid #0C2F53; border-radius: 2px; font-size: 10px; font-weight: 600; color: #FFEF01;"
                  >
                    {{ $t('Save') }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-else>
      <div class="text-xs-center mt-4 mb-4">
        <v-icon x-large>error_outline</v-icon>
        <p>No detail</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import Typography from '@/components/elements/Typography.vue'
export default {
  props: ['value', 'pageid', 'theme'],
  components: {
    Multiselect
  },
  data: function() {
    return {
      loading: true,
      user: undefined,
      chatboxHeight: 0,
      session: '',
      assignadminname: '',
      showHistory: false,
      depamemberlogs: [],
      AdminNote: '',
      AdminTag: [],
      showAdminNoteBox: false,
      showAdminTagBox: false,
      selectedTags: [],
      tagOptions: [],
      UserInfoTitle: [
        'รหัสสมาชิก : ',
        'เลขบัตรประจำตัวประชาชน : ',
        'ชื่อ - นามสกุล : ',
        'วันเกิด : ',
        'เบอร์ : ',
        'อีเมล : ',
        'ประเภทสมาชิก : ',
        'ประเภท : ',
        'เลขเกษตรกร : ',
        'เข้าร่วมวันที่ : '
      ],
      UserInfo: [],
      StoreInfoTitle: ['ชื่อบริษัท : ', 'เว็บไซต์ : ', 'เบอร์ : ', 'ตัวแทนขาย : '],
      StoreInfo: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted: function() {
    var vm = this

    vm.loading = true

    vm.getUser(vm.value.userid)
      .then(
        function(user) {
          if (user) {
            vm.user = user
            vm.session = user.session ? user.session : ''
            vm.assignadminname = user.adminname
            // console.log(vm.user)
            vm.SetUserInfo(vm.user)
            vm.SetStoreInfo(vm.user)
            if (vm.user.tags) {
              vm.selectedTags = vm.user.tags.split(',')
              vm.tagOptions = vm.user.tags.split(',')
            }
          }
          vm.loading = false
        },
        function(error) {
          vm.loading = false
        }
      )
      .finally(() => {
        vm.loading = false
      })
    // console.log(this)
  },
  methods: {
    SetUserInfo(user) {
      // console.log(user)
      if (user.member_id != undefined) this.UserInfo.push(user.member_id)
      else this.UserInfo.push(' - ')
      if (user.member_info[0] != undefined && user.member_info[0].id_card != undefined)
        this.UserInfo.push(user.member_info[0].id_card)
      else this.UserInfo.push(' - ')
      if (user.member_info[0] != undefined && user.member_info[0].coordinator_name != undefined)
        this.UserInfo.push(user.member_info[0].coordinator_name)
      else this.UserInfo.push(' - ')
      if (user.member_info[0] != undefined && user.member_info[0].dob != undefined)
        this.UserInfo.push(user.member_info[0].dob)
      else this.UserInfo.push(' - ')
      if (user.member_info[0] != undefined && user.member_info[0].phone_number != undefined)
        this.UserInfo.push(user.member_info[0].phone_number)
      else this.UserInfo.push(' - ')
      if (user.member_info[0] != undefined && user.member_info[0].email != undefined)
        this.UserInfo.push(user.member_info[0].email)
      else this.UserInfo.push(' - ')
      if (user.membertype[0] != undefined && user.membertype[0] != undefined)
        this.UserInfo.push(user.membertype[0])
      else this.UserInfo.push(' - ')
      if (user.member_info[0] != undefined && user.member_info[0].dptype != undefined)
        this.UserInfo.push(user.member_info[0].dptype)
      else this.UserInfo.push(' - ')
      if (user.member_info[0] != undefined && user.member_info[0].profile_center_id != undefined)
        this.UserInfo.push(user.member_info[0].profile_center_id)
      else this.UserInfo.push(' - ')
      if (user.member_info[0] != undefined && user.member_info[0].timestamp != undefined) {
        let temp = user.member_info[0].timestamp.substring(0, 10)
        this.UserInfo.push(temp)
      } else this.UserInfo.push(' - ')
      // console.log(this.UserInfo)
    },
    SetStoreInfo(user) {
      // console.log(user)
      if (user.tp_info[0] != undefined && user.tp_info[0].name != undefined)
        this.StoreInfo.push(user.tp_info[0].name)
      else this.StoreInfo.push(' - ')
      if (user.tp_info[0] != undefined && user.tp_info[0].website != undefined)
        this.StoreInfo.push(user.tp_info[0].website)
      else this.StoreInfo.push(' - ')
      if (user.tp_info[0] != undefined && user.tp_info[0].phone != undefined)
        this.StoreInfo.push(user.tp_info[0].phone)
      else this.StoreInfo.push(' - ')
      if (user.tp_info[0] != undefined && user.tp_info[0].salesrepresentatives != undefined)
        this.StoreInfo.push(user.tp_info[0].salesrepresentatives)
      else this.StoreInfo.push(' - ')
      // console.log(this.StoreInfo)
    },
    checkUndefined(val1 = true, val2 = true) {
      if (val1 != undefined && val2 != undefined) return true
      return false
    },
    PUTusertags() {
      let res = ''
      for (let i = 0; i < this.selectedTags.length; i++) {
        res = res + this.selectedTags[i] + ','
      }
      res = res.slice(0, -1)
      // console.log(res)

      var data = {
        pageid: this.$store.state.livechat.pageid,
        usersid: this.user.id,
        tags: res
      }
      console.log(data)
      api.saveUserTags(data, (error, response) => {
        if (error) {
        }
      })
    },
    POSTupdateUserNoteDetail() {
      const text = document.getElementById('adminNote')
      let adminNote = text.value
      // console.log(adminNote == "");
      var param = this.$store.state.livechat.pageid
      var data = {
        userid: this.user.id,
        note: adminNote
      }
      api.updateUserNoteDetail(data, param, (error, response) => {
        if (error) {
        }
      })
    },
    addTag(newTag) {
      // console.log(newTag)
      const tag = newTag
      // console.log(tag)
      this.tagOptions.push(tag)
      this.selectedTags.push(tag)
    },
    changeAsssign(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          adminname: value
        }
      }
      api.saveuseradminname(data, (error, response) => {
        if (error) {
          // reject(error)
        }
      })
    },
    changeSession(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          session: value
        }
      }
      api.saveusersession(data, (error, response) => {
        if (error) {
          // reject(error)
        }
      })
    },
    onResizeChatbox: function() {
      var vm = this
      setTimeout(() => {
        vm.chatboxHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
      }, 500)
    },
    imgError: function(event, el) {
      // console.log('not load')
      this.user.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    getUser: function(userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.$store.state.livechat.pageid
        }
        api.getUserOnly(data, function(error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
    async depamemberlog() {
      this.loading = true
      try {
        var params = {
          limit: this.limitCom,
          offset: this.offsetCom
        }
        this.data = await api.depamemberlogs(this.user.member_id, params)

        // console.log(this.data)
        this.depamemberlogs = this.data.data
        // console.log(this.depamemberlogs)
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      var vm = this

      if (newVal == null) {
        vm.user = undefined
      } else if (newVal.id != oldVal.id) {
        vm.loading = true

        vm.getUser(newVal.userid)
          .then(
            function(user) {
              if (user) {
                vm.user = user
              }
              vm.loading = false
            },
            function(error) {
              vm.loading = false
            }
          )
          .finally(() => {
            vm.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.left {
  font-weight: 600;
  font-size: 14px;
  color: #2c2c2c;
}

.right {
  font-weight: 400;
  font-size: 14px;
  color: #0c2f53;
  margin-left: 10px;
  overflow-wrap: anywhere;
  hyphens: auto;
}

.custom-scroll::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.custom-scroll::-webkit-scrollbar-track {
  background-color: none;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #0c2f53;
  border-radius: 20px;
}

.textBox {
  overflow-y: hidden;
  align-items: start !important;
  font-size: 10px;
  text-align: left;
  padding: 5px;
  box-shadow: none;
  width: 243px;
  height: 77px;
  background: #ffffff;
  border: 1px solid #0c2f53;
  border-radius: 11px;
}

.tagBox {
  align-items: start !important;
  font-size: 10px;
  text-align: left;
  padding: 5px;
  box-shadow: none;
  width: 243px;
  height: 77px;
  background: #ffffff;
  border: 1px solid #0c2f53;
  border-radius: 11px;
}

.tag {
  font-weight: 400;
  font-size: 14px;
  position: relative;
  display: inline-block;
  padding: 4px 10px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  background: #1a273c !important;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-userinfo.vue